import { BehaviorSubject, Observable } from "rxjs";
import { UserSession } from "../interfaces/user-session";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { HttpOptions } from '../interfaces/http-options';
import { DeleteResult } from "../models/net/result/crud/delete-result";
import { UpdateResult } from "../models/net/result/crud/update-result";
import { ReadResult } from "../models/net/result/crud/read-result";
import { CreateResult } from "../models/net/result/crud/create-result";
import { AppService } from "../services/app.service";
import { UtilityFunctions } from "./utility-functions";

export class HttpCrudFactory {

    private constructor() { }

    public static search<TRequest, TResult>(http: HttpClient, controllerName: string, apiBaseUrl: string, request: TRequest): Observable<TResult[] | null> {

        let result: BehaviorSubject<TResult[] | null> = new BehaviorSubject<TResult[] | null>(null);
        const apiPath: string = controllerName + "/search";
        const fullPath: string = apiBaseUrl + apiPath;
        let httpOptions: any | null = this.getHttpOptions();

        http.post<TResult[] | null>(fullPath, request, httpOptions).subscribe((r: any | null) => {

            result.next(r);
            result.complete();

        }, error => {

            result.next(error);
        });

        return result;
    }

    public static create<TEnvelope>(http: HttpClient, controllerName: string, apiBaseUrl: string, envelope: TEnvelope): Observable<CreateResult | null> {

        let result: BehaviorSubject<CreateResult | null> = new BehaviorSubject<CreateResult | null>(null);
        let apiPath: string = controllerName + "/envelope/create";
        const fullPath: string = apiBaseUrl + apiPath;
        const loggedUserSession: any = UtilityFunctions.getUserSession(); // localStorage.getItem("userSession");

        if (loggedUserSession) {

            const userSession: UserSession = JSON.parse(loggedUserSession);
            let authorizationHeaderValue: string = "Bearer " + userSession.bearerToken;

            const httpOptions = { headers: new HttpHeaders({ "content-type": "application/json", "Authorization": authorizationHeaderValue }) };

            http.post<TEnvelope | null>(fullPath, envelope, httpOptions).subscribe((r: any | null) => {

                result.next(r);
                result.complete();

            }, error => {

                result.next(error);
            });
        }

        return result;
    }

    public static read(http: HttpClient, controllerName: string, apiBaseUrl: string, id: number): Observable<ReadResult | null> {

        let result: BehaviorSubject<ReadResult | null> = new BehaviorSubject<ReadResult | null>(null);
        let apiPath: string = controllerName + "/envelope/read/" + id.toString();
        const fullPath: string = apiBaseUrl + apiPath;
        const loggedUserSession: any = UtilityFunctions.getUserSession(); // localStorage.getItem("userSession");

        if (loggedUserSession) {

            const userSession: UserSession = JSON.parse(loggedUserSession);
            let authorizationHeaderValue: string = "Bearer " + userSession.bearerToken;

            const httpOptions = { headers: new HttpHeaders({ "content-type": "application/json", "Authorization": authorizationHeaderValue }) };

            http.get<ReadResult | null>(fullPath, httpOptions).subscribe((r: any | null) => {

                result.next(r);
                result.complete();

            }, error => {

                result.next(error);
            });
        }

        return result;
    }

    public static update<TEnvelope>(http: HttpClient, controllerName: string, apiBaseUrl: string, envelope: TEnvelope, itemId: number): Observable<UpdateResult | null> {

        let result: BehaviorSubject<UpdateResult | null> = new BehaviorSubject<UpdateResult | null>(null);
        let apiPath: string = controllerName + "/envelope/update";
        const fullPath: string = apiBaseUrl + apiPath;
        const loggedUserSession: any = UtilityFunctions.getUserSession(); // localStorage.getItem("userSession");

        if (loggedUserSession) {

            const userSession: UserSession = JSON.parse(loggedUserSession);
            let authorizationHeaderValue: string = "Bearer " + userSession.bearerToken;

            const httpOptions = { headers: new HttpHeaders({ "content-type": "application/json", "Authorization": authorizationHeaderValue }) };

            http.put<UpdateResult | null>(fullPath, envelope, httpOptions).subscribe((r: any | null) => {

                result.next(r);
                result.complete();

            }, error => {

                result.next(error);
            });
        }

        return result;
    }

    public static delete(http: HttpClient, controllerName: string, apiBaseUrl: string, itemId: number): Observable<DeleteResult | null> {

        let result: BehaviorSubject<DeleteResult | null> = new BehaviorSubject<DeleteResult | null>(null);
        let apiPath: string = controllerName + "/envelope/delete/" + itemId.toString();
        const fullPath: string = apiBaseUrl + apiPath;
        const loggedUserSession: any = UtilityFunctions.getUserSession(); // localStorage.getItem("userSession");

        if (loggedUserSession) {

            const userSession: UserSession = JSON.parse(loggedUserSession);
            let authorizationHeaderValue: string = "Bearer " + userSession.bearerToken;

            const httpOptions = { headers: new HttpHeaders({ "content-type": "application/json", "Authorization": authorizationHeaderValue }) };

            http.delete<DeleteResult | null>(fullPath, httpOptions).subscribe((r: DeleteResult | null) => {

                result.next(r);
                result.complete();

            }, error => {

                result.next(error);
            });
        }

        return result;
    }

    public static getBlankEnvelope<TEnvelope>(http: HttpClient, controllerName: string, apiBaseUrl: string): Observable<TEnvelope | null> {

        let result: BehaviorSubject<TEnvelope | null> = new BehaviorSubject<TEnvelope | null>(null);
        let apiPath: string = controllerName + "/envelope/getnew";
        const fullPath: string = apiBaseUrl + apiPath;
        const loggedUserSession: any = UtilityFunctions.getUserSession(); // localStorage.getItem("userSession");
        //let httpOptions: any | null = this.getHttpOptions();

        if (loggedUserSession) {

            const userSession: UserSession = JSON.parse(loggedUserSession);
            let authorizationHeaderValue: string = "Bearer " + userSession.bearerToken;

            const httpOptions = { headers: new HttpHeaders({ "content-type": "application/json", "Authorization": authorizationHeaderValue }) };

            http.get<TEnvelope | null>(fullPath, httpOptions).subscribe((r: TEnvelope | null) => {

                result.next(r);
                result.complete();

            }, error => {

                result.next(error);
            });
        }

        return result;
    }

    public static get(http: HttpClient, apiBaseUrl: string, path: string): Observable<ReadResult | null> {

        let result: BehaviorSubject<ReadResult | null> = new BehaviorSubject<ReadResult | null>(null);
        const fullPath: string = apiBaseUrl + path;
        const loggedUserSession: any = UtilityFunctions.getUserSession(); // localStorage.getItem("userSession");

        if (loggedUserSession) {

            const userSession: UserSession = JSON.parse(loggedUserSession);
            let authorizationHeaderValue: string = "Bearer " + userSession.bearerToken;

            const httpOptions = { headers: new HttpHeaders({ "content-type": "application/json", "Authorization": authorizationHeaderValue }) };

            http.get<ReadResult | null>(fullPath, httpOptions).subscribe((r: any | null) => {

                result.next(r);
                result.complete();

            }, error => {

                result.next(error);
            });
        }

        return result;
    }

    private static getHttpOptions(): HttpOptions  {

        let result: HttpOptions | null = null;

        const loggedUserSession: any = UtilityFunctions.getUserSession(); // localStorage.getItem("userSession");

        if (loggedUserSession) {

            const userSession: UserSession = JSON.parse(loggedUserSession);
            let authorizationHeaderValue: string = "Bearer " + userSession.bearerToken;

            result = { headers: new HttpHeaders({ "content-type": "application/json", "Authorization": authorizationHeaderValue }) };

        } else {

            result = { headers: new HttpHeaders({ "content-type": "application/json" }) };
        }

        return result;
    }
}
